import React from 'react';
import createSvgIcon from './utils/create-svg-icon';
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowToLeft = createSvgIcon({
  path: [/*#__PURE__*/_jsx("path", {
    d: "M15.1213 7.70711C15.5118 7.31658 15.5118 6.68342 15.1213 6.29289C14.7308 5.90237 14.0976 5.90237 13.7071 6.29289L4 16L13.7071 25.7071C14.0976 26.0976 14.7308 26.0976 15.1213 25.7071C15.5118 25.3166 15.5118 24.6834 15.1213 24.2929L7.82843 17H27C27.5523 17 28 16.5523 28 16C28 15.4477 27.5523 15 27 15H7.82843L15.1213 7.70711Z",
    fill: "#050038"
  }, "0")],
  rect: [],
  displayName: 'ArrowToLeft',
  viewBox: '0 0 32 32'
});
export default ArrowToLeft;